const module = { name: 'Fandango/Dialog', exports: {} }; const exports = module.exports;



import { default as $ } from 'swug-fdRequire-call:jQuery';



const Styles = {
    OPEN: 'open',
}


const EventNames = {
    CLOSED: 'close',
    OPENED: 'open',
}


const DataAttribs = {
    OPEN_TRIGGER: 'data-micromodal-trigger',
    CLOSE_TRIGGER: 'data-micromodal-close',
}


const FdDialog = function dialogConstructor(dialogID, opts) {
    const dialog = this;
    dialog.id = dialogID.replace('#', '');
    dialog.opts = $.extend({
        closeOnBgClick: true,
        closeOnEsc: true
    }, opts);
    if (dialog.opts.closeOnBgClick) {
        const bgOverlay = document.getElementById(dialog.id);
        bgOverlay && bgOverlay.setAttribute(DataAttribs.CLOSE_TRIGGER, 'true');
    }
}
FdDialog.prototype.close = function closeDialog() {
    const dialog = this;
    window.MicroModal.close(dialog.id);
    return dialog;
};
FdDialog.prototype.open = function openDialog() {
    const dialog = this;
    window.MicroModal.show(dialog.id, {
        awaitCloseAnimation: false,
        debugMode: true,
        disableCloseOnEscape: !dialog.opts.closeOnEsc,
        disableScroll: true,
        onClose: function onClose() {
            dialog.emit(EventNames.CLOSED);
        },
        onShow: function onShow() {
            dialog.emit(EventNames.OPENED);
        },
        openClass: Styles.OPEN,
    });
    return dialog;
};
$.extend(FdDialog.prototype, $.eventEmitter);
FdDialog.EventNames = EventNames;
module.exports = FdDialog;
export default module.exports;